import {
  PROPOSAL_TYPE,
  PROPOSAL_TYPE_MAP
} from '@vzmi/shp_shared_compo/constants/proposal'
import { FormValueSelector } from '../../../Common/forms'
import ProposalCompletion from '../../Common/ProposalCompletion/ProposalCompletion'
import { ConvertedDesc } from '../PageTitle'

const SuccessPage = () => {
  const proposalType = PROPOSAL_TYPE.UPDATE_LISTING
  return (
    <FormValueSelector
      selector={select => ({
        proposalId: select('proposal.id'),
        subProposals: select('proposal.subProposals')
      })}
    >
      {({ proposalId, subProposals = [] }) => {
        return (
          <ProposalCompletion
            title={`修改${PROPOSAL_TYPE_MAP[proposalType]}提案已送出`}
            subTitle='提案編號：'
            proposalId={proposalId}
            proposalType={proposalType}
            withHint
          >
            <h2>
              <ConvertedDesc
                subProposals={subProposals}
                withOverviewLink
              />
            </h2>
          </ProposalCompletion>
        )
      }}
    </FormValueSelector>
  )
}

export default SuccessPage
